__turbopack_context__.v({
  "icon": "nsXDLa_icon",
  "image": "nsXDLa_image",
  "name": "nsXDLa_name",
  "noImage": "nsXDLa_noImage",
  "quote": "nsXDLa_quote",
  "quoteCard": "nsXDLa_quoteCard",
  "zitat": "nsXDLa_zitat",
});
